import React, { lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import Private from './components/Route/Private';
import Public from './components/Route/Public';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

const Routes = () => (
  <Switch>
    <Private
      component={lazy(() => import("./views/Dashboard"))}
      exact
      layout={MainLayout}
      path="/dashboard"
    />
    <Private
      component={lazy(() => import("./views/Complaints"))}
      exact
      layout={MainLayout}
      path="/complaints"
    />
    <Private
      component={lazy(() => import("./views/Complaint"))}
      exact
      layout={MainLayout}
      path="/complaints/:id"
    />
    <Private
      component={lazy(() => import("./views/Account"))}
      exact
      layout={MainLayout}
      path="/account"
    />
    <Private
      component={lazy(() => import("./views/Settings"))}
      exact
      layout={MainLayout}
      path="/settings"
    />
    <Public
      component={lazy(() => import("./views/ForgotPassword"))}
      exact
      layout={MinimalLayout}
      path="/forgot/:token?"
    />
    <Public
      component={lazy(() => import("./views/SignIn"))}
      exact
      layout={MinimalLayout}
      path="/sign-in"
    />
    <Redirect from="/*" to="/dashboard" />
  </Switch>
);

export default Routes;
